export const MAX_FORM_WIDTH = '1200px';
export const SIDE_MENU_WIDTH = '250px';
export const TOP_MENU_HEIGHT = '81px';
export const TOP_MENU_HEIGHT_MOBILE = '64px';
